'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recharts = require('recharts');

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

var _chartTooltipWrapper = require('../chart-tooltip-wrapper');

var _chartTooltipWrapper2 = _interopRequireDefault(_chartTooltipWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SGLineChart(props) {
  var data = props.data,
      xAxisKey = props.xAxisKey,
      tickFormatterX = props.tickFormatterX,
      syncId = props.syncId,
      elementsIds = props.elementsIds,
      filteredElementsIds = props.filteredElementsIds,
      onMouseWheel = props.onMouseWheel,
      renderTooltip = props.renderTooltip,
      _props$xAxisWidth = props.xAxisWidth,
      xAxisWidth = _props$xAxisWidth === undefined ? 30 : _props$xAxisWidth,
      _props$yAxisWidth = props.yAxisWidth,
      yAxisWidth = _props$yAxisWidth === undefined ? 50 : _props$yAxisWidth;

  // TODO: Implement actual line chart zoom -> https://jsfiddle.net/alidingling/nhpemhgs/

  return _react2.default.createElement(
    'div',
    {
      ref: function ref(_ref) {
        if (_ref && typeof onMouseWheel === 'function') {
          // IE9, Chrome, Safari, Opera
          _ref.addEventListener('mousewheel', onMouseWheel, false);
          // Firefox
          _ref.addEventListener('DOMMouseScroll', onMouseWheel, false);
        }
      }
    },
    _react2.default.createElement(
      _recharts.ResponsiveContainer,
      { height: 300, debounce: 100 },
      _react2.default.createElement(
        _recharts.LineChart,
        { data: data, syncId: syncId },
        _react2.default.createElement(_recharts.YAxis, { axisLine: false, tickLine: false, width: yAxisWidth }),
        _react2.default.createElement(_recharts.XAxis, {
          dataKey: xAxisKey,
          tickFormatter: function tickFormatter(value) {
            if (tickFormatterX) {
              return tickFormatterX(value);
            }

            return value;
          },
          axisLine: false,
          padding: { right: 50 },
          width: xAxisWidth,
          tickLine: false
        }),
        _react2.default.createElement(_recharts.CartesianGrid, { vertical: false }),
        renderTooltip && (0, _chartTooltipWrapper2.default)({ renderTooltip: renderTooltip }),
        filteredElementsIds.map(function (key) {
          return _react2.default.createElement(_recharts.Line, {
            key: key,
            dataKey: key,
            stroke: (0, _utils2.default)(elementsIds.indexOf(key))
          });
        })
      )
    )
  );
}

SGLineChart.propTypes = {
  data: _propTypes2.default.arrayOf(_propTypes2.default.object),
  xAxisKey: _propTypes2.default.string.isRequired,
  tickFormatterX: _propTypes2.default.func,
  syncId: _propTypes2.default.string,
  elementsIds: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  filteredElementsIds: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  renderTooltip: _propTypes2.default.func,
  xAxisWidth: _propTypes2.default.number,
  yAxisWidth: _propTypes2.default.number,
  // eslint-disable-next-line
  zoom: _propTypes2.default.number,
  onMouseWheel: _propTypes2.default.func
};

exports.default = SGLineChart;